import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { HeartOff } from 'lucide-react';
import { api } from '@/lib/api';
import MansionCard from '@/components/mansion/MansionCard';

export default function FavoritesPage() {
  const { data, isLoading } = useQuery({ queryKey: ['favorites'], queryFn: () => api.favorites() });

  return (
    <div className="yd-container py-8">
      <h1 className="mb-1 font-display text-2xl font-bold text-ink-900">Favorilerim</h1>
      <p className="mb-6 text-sm text-ink-500">Beğendiğiniz mekanları burada saklıyoruz.</p>

      {isLoading && (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => <div key={i} className="yd-skeleton h-72" />)}
        </div>
      )}

      {data?.items.length === 0 && (
        <div className="yd-card flex flex-col items-center gap-3 p-12 text-center" data-testid="favorites-empty">
          <HeartOff className="h-10 w-10 text-ink-300" aria-hidden />
          <p className="text-ink-500">Henüz favori mekanınız yok.</p>
          <Link to="/ara" className="yd-btn-primary">Mekanları Keşfet</Link>
        </div>
      )}

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="favorites-grid">
        {data?.items.map((m) => (
          <MansionCard key={m.id} mansion={{ ...m, isFavorite: true }} />
        ))}
      </div>
    </div>
  );
}
